<template>
  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
      <tr>
        <th scope="col">
          <a @click.prevent="onSortBy('id')" :class="{active: sortByIs('id')}" class="d-flex align-items-end" href="#">
            <span>ID</span>
            <div class="ms-auto" v-show="sortByIs('id')">
              <i v-if="sortAsc" class="fa-solid fa-sort-up"></i>
              <i v-else class="fa-solid fa-sort-down"></i>
            </div>
          </a>
        </th>
        <th scope="col">
          <a @click.prevent="onSortBy('Locality')" :class="{active: sortByIs('Locality')}" class="d-flex align-items-end" href="#">
            <span>Ort</span>
            <div class="ms-auto" v-show="sortByIs('Locality')">
              <i v-if="sortAsc" class="fa-solid fa-sort-up"></i>
              <i v-else class="fa-solid fa-sort-down"></i>
            </div>
          </a>
        </th>
        <th scope="col">Beschreibung</th>
        <th scope="col">
          <a @click.prevent="onSortBy('currentstate')" :class="{active: sortByIs('currentstate')}" class="d-flex align-items-end" href="#">
            <span>Status</span>
            <div class="ms-auto" v-show="sortByIs('currentstate')">
              <i v-if="sortAsc" class="fa-solid fa-sort-up"></i>
              <i v-else class="fa-solid fa-sort-down"></i>
            </div>
          </a>
        </th>
        <th scope="col">
          <a @click.prevent="onSortBy('LastUpdate')" :class="{active: sortByIs('LastUpdate')}" class="d-flex align-items-end" href="#">
            <span>L. Update</span>
            <div class="ms-auto" v-show="sortByIs('LastUpdate')">
              <i v-if="sortAsc" class="fa-solid fa-sort-up"></i>
              <i v-else class="fa-solid fa-sort-down"></i>
            </div>
          </a>
        </th>
        <th scope="col">
          <a @click.prevent="onSortBy('LastContact')" :class="{active: sortByIs('LastContact')}" class="d-flex align-items-end" href="#">
            <span>L. Kontakt</span>
            <div class="ms-auto" v-show="sortByIs('LastContact')">
              <i v-if="sortAsc" class="fa-solid fa-sort-up"></i>
              <i v-else class="fa-solid fa-sort-down"></i>
            </div>
          </a>
        </th>
        <th scope="col">L. Kontakt<br> Status</th>
        <th scope="col">Signal Level</th>
        <th scope="col">Aktionen</th>
      </tr>
      </thead>
      <tbody>
      <detector-row @open-detector-form="openDetectorForm" v-for="detector in detectorsSorted" :key="detector.identifier" :detector="detector" />
      </tbody>
    </table>
  </div>
  <DetectorForm :id="detectorId" />
</template>

<script setup>
import Modal from "bootstrap/js/dist/modal";
import { ref, computed } from 'vue';
import { useStore } from "vuex";
import DetectorRow from "@/components/DetectorRow.vue";
import DetectorForm from "@/components/DetectorForm.vue";

const store = useStore();

const sortBy = ref("id");
const sortOrder = ref("asc");
const detectorId = ref(null);


const openDetectorForm = (id) => {
  detectorId.value = id;
  const detectorForm = document.getElementById('detectorForm');
  const detectorFormModal = Modal.getOrCreateInstance(detectorForm);
  detectorFormModal.show();
  detectorForm.addEventListener('hidden.bs.modal', () => {
    detectorId.value = null;
  });
};

const detectorsSortedBy = (sortBy = '', direction = 'asc') => {
  switch (sortBy) {
    case 'id':
      return direction === 'asc' ? store.getters.detectorsSortedByIdAsc : store.getters.detectorsSortedByIdDesc;
    case 'Locality':
      return direction === 'asc' ? store.getters.detectorsSortedByLocalityAsc : store.getters.detectorsSortedByLocalityDesc;
    case 'currentstate':
      return direction === 'asc' ? store.getters.detectorsSortedByCurrentStateAsc : store.getters.detectorsSortedByCurrentStateDesc;
    case 'LastUpdate':
      return direction === 'asc' ? store.getters.detectorsSortedByLastUpdateAsc : store.getters.detectorsSortedByLastUpdateDesc;
    case 'LastContact':
      return direction === 'asc' ? store.getters.detectorsSortedByLastContactAsc : store.getters.detectorsSortedByLastContactDesc;
    default:
      return store.getters.detectorsSortedByIdAsc;
  }
};
const detectorsSorted = computed(() => detectorsSortedBy(sortBy.value, sortOrder.value));
const sortAsc = computed(() => sortOrder.value === "asc");

const sortByIs = (name) => sortBy.value === name;
const onSortBy = (name) => {
  if(sortBy.value === name) {
    sortOrder.value = sortOrder.value === "desc" ? "asc" : "desc";
  }
  sortBy.value = name;
};

</script>


<style scoped>
</style>
